import React, { useState } from 'react';
import Daily1 from './daily1';

const AnimalParentComponent = () => {
  const [selectedButton, setSelectedButton] = useState(0);

  const handleButtonClick = (e, index) => {
    e.preventDefault();
    setSelectedButton(index);
  };

  // Button data
  const buttonData = [
    { imageSrc: 'https://images.pexels.com/photos/4001296/pexels-photo-4001296.jpeg?auto=compress&cs=tinysrgb&w=400', title: 'Rabbit', location: 'Central-America, North-America' },
    { imageSrc: 'https://images.pexels.com/photos/1770706/pexels-photo-1770706.jpeg?auto=compress&cs=tinysrgb&w=400', title: 'Koala', location: 'Oceania' },
    { imageSrc: 'https://images.pexels.com/photos/3608263/pexels-photo-3608263.jpeg?auto=compress&cs=tinysrgb&w=400', title: 'Panda', location: 'Asia' },
    { imageSrc: 'https://images.pexels.com/photos/50577/hedgehog-animal-baby-cute-50577.jpeg?auto=compress&cs=tinysrgb&w=400', title: 'Hedgehog', location: 'Africa, Asia, Eurasia, Europe' },
  ];

  return (
    <div className="untree_co-section">
      <div className="container">
        <div className="row justify-content-center text-center mb-5">
          <div className="col-lg-6">
            <h2 className="section-title text-center mb-3">Daily Animal Spotlight</h2>
            <br />
            <h5 className="section-title text-center mb-3">Cute Herbivorous Animals</h5>
            <p>
              These adorable animals not only bring joy but also play vital roles in their ecosystems. Explore their
              natural habitats, unique adaptations, and how their herbivorous diets shape their lives. As we celebrate
              these delightful beings, we also recognize the importance of preserving their habitats and ensuring their
              well-being for generations to come.
            </p>
          </div>
        </div>
        <div className="row">
          {buttonData.map((button, index) => (
            <div key={index} className="col-6 col-sm-6 col-md-6 col-lg-3 mb-4 mb-lg-0">
              <div className="media-1">
                <a href="#" className="d-block mb-3"  onClick={(e) => handleButtonClick(e, index)}>
                  <img src={button.imageSrc} alt="Image" className="img-fluid" />
                </a>
                <span className="d-flex align-items-center loc mb-2">
                  <span className="icon-room mr-3"></span>
                  <span>{button.location}</span>
                </span>
                <div className="d-flex align-items-center">
                  <div>
                    <h3>
                      <a href="#">
                        {button.title}
                      </a>
                    </h3>
                    <div className="price ml-auto">
                      <span>Mammal</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Pass the selectedButton prop to the Daily1 component */}
      <Daily1 selectedButton={selectedButton} />
    </div>
  );
};

export default AnimalParentComponent;
